import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closedx",
  "use": "icon-closedx-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-closedx\">\n        <path d=\"M28 2.99998L3.25124 27.7487L1.12992 25.6274L25.8787 0.878662L28 2.99998Z\" fill=\"white\" />\n        <path d=\"M2.99998 0.999983L27.7487 25.7487L25.6274 27.87L0.878662 3.1213L2.99998 0.999983Z\" fill=\"white\" />\n    </symbol>"
});
var result = sprite.add(symbol);
export default symbol